<section
  [class]="collapsed ? marginWhenCollapsed : marginWhenOpen"
  class="transition-[margin] duration-200"
>
  <button
    (click)="toggle()"
    class="group block w-full text-left"
    [attr.aria-expanded]="!collapsed"
    [attr.aria-controls]="contentId"
  >
    <div class="flex w-full items-center justify-between">
      <div class="flex items-center gap-3">
        <div
          class="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100"
        >
          <lucide-icon
            [name]="icon"
            class="text-primary-600"
            [size]="16"
          ></lucide-icon>
        </div>
        <h2 class="text-lg font-semibold text-greyscale-800">
          {{ title }}
        </h2>
      </div>
      <lucide-icon
        name="chevron-down"
        [class]="collapsed ? '' : 'rotate-180'"
        class="text-greyscale-400 transition-all duration-200 group-hover:text-primary-400"
        [size]="18"
      ></lucide-icon>
    </div>
    <div
      [class]="collapsed ? 'mt-4 mb-0' : 'my-6'"
      class="h-px bg-greyscale-200 transition-all duration-200 group-hover:bg-primary-200"
    ></div>
  </button>

  <div
    class="grid transition-[grid-template-rows] duration-200 ease-out"
    [class.grid-rows-[1fr]]="!collapsed"
    [class.grid-rows-[0fr]]="collapsed"
  >
    <div [id]="contentId" class="overflow-hidden">
      <ng-content></ng-content>
    </div>
  </div>
</section>
